<template>
  <div v-show="show" @click.self="dismiss" class="modal-bg">
    <div id="formatting-instructions" class="modal">

      <h1 class="txt-bold">Tekstisisällön editointi:</h1>
      <br>

      <p>
        <strong>Periaate:</strong> Tekstin editointi tapahtuu kirjoittamalla tekstin joukkoon tageja, esim: <strong>{{this.tips.basics}}</strong>.
        <br><br>
        <strong>Käyttö:</strong> haluttu tekstisisältö kirjoitetaan aloitus- ja lopetustagin sisään, esim: <strong>{{this.tips.usage}}</strong>.
        <br><br>
        <strong>Lisäksi:</strong> tageja voidaan kirjoittaa sisäkkäin niin useasti kuin on tarve, esim. <strong>{{this.tips.also}}</strong>.
      </p>

      <div class="oflow-y-auto mt-4 border-l3 p-2" style="max-height: 350px;">

        <h1 class="txt-bold">Esimerkit:</h1>
        <br>

        <p class="color-theme txt-bold mb-1">Otsikko, iso:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.header1}}</p>
        <span>tulostus:</span>
        <p v-html="header1"></p>

        <hr>

        <p class="color-theme txt-bold mb-1">Otsikko, pieni:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.header2}}</p>
        <span>tulostus:</span>
        <p v-html="header2"></p>

        <hr>

        <p class="color-theme txt-bold mb-1">Paragrafi / kappale:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.paragraph}}</p>
        <span>tulostus:</span>
        <p v-html="paragraph"></p>

        <hr>

        <p class="color-theme txt-bold mb-1">Lihavointi:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.strong}}</p>
        <span>tulostus:</span>
        <p class="ssstrong" v-html="strong"></p>

        <hr>

        <p class="color-theme txt-bold mb-1">Linkki:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.alink}}</p>
        <span>tulostus:</span>
        <p class="ssstrong" v-html="alink"></p>
        <br>
        <p class="mt-1">
          <span style="display: inline-block; font-weight: bold; color: rgb(255, 187, 0);">HUOM!</span>
          Jos halutaan linkittää toiselle sivulle niin, että linkki avaa selaimeen kokonaan uuden välilehden:
          <br>
          <span>{{ this.blink }}</span>
        </p>

        <hr>

        <p class="color-theme txt-bold mb-1">Rivin vaihto:</p>
        <span>koodi:</span>
        <p>{{this.breaker}}</p>
        <p class="mt-1">
          <span style="display: inline-block; font-weight: bold; color: rgb(255, 187, 0);">HUOM!</span>
          <strong> {{this.breaker}}</strong> -tagi on "itsenäinen" eikä sen sisään voi lisätä muuta sisältöä.
        </p>

        <hr>

        <p class="color-theme txt-bold mb-1">Tyhjä rivi:</p>
        <span>koodi:</span>
        <p>{{this.breaker}}{{this.breaker}}</p>

        <hr>

        <p class="color-theme txt-bold mb-1">Lista, numeroitu:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.oListSet}}</p>
        <span>tulostus:</span>
        <p v-html="oListSet"></p>

        <hr>

        <p class="color-theme txt-bold mb-1">Lista, numeroimaton:</p>
        <span>koodi:</span>
        <p class="mb-1">{{this.uListSet}}</p>
        <span>tulostus:</span>
        <p v-html="uListSet"></p>

      </div>
      <br>
      <button @click="dismiss" class="btn txt-center">Sulje</button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
      // default: false
    }
  },

  data () {
    return {
      tips: {
        basics: '<xxx> </xxx>',
        usage: '<xxx>tekstisisältö</xxx>',
        also: '<xxx1>teksti 1<xxx2>teksti 2</xxx2></xxx1>'
      },
      exampleStart: '<xxx>',
      exampleEnd: '</xxx>',
      paragraph: '<p>tekstisisältö</p>',
      alink: '<a href="www.tähänosoite.fi">linkki</a>',
      blink: '<a href="www.tähänosoite.fi" target="_blank" rel="noopener noreferrer">linkki</a>',
      strong: '<strong>lihavoitu teksti</strong>',
      header1: '<h1>otsikko 1</h1>',
      header2: '<h2>otsikko 2</h2>',
      breaker: '<br>',
      oList: '<ol>numeroitu lista</ol>',
      uList: '<ul>numeroimaton lista</ul>',
      listItem: '<li>listan asia</li>',
      oListSet: '<ol><li>asia a</li><li>asia b</li><li>asia c</li></ol>',
      uListSet: '<ul><li>asia a</li><li>asia b</li><li>asia c</li></ul>'
    }
  },

  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },

  methods: {
    dismiss () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
#formatting-instructions {
  /* ul {
    list-style: initial !important;
  } */
  ul {
    list-style: unset !important;
    //list-style-type: disc !important;
    //list-style-position: inside !important;
    padding-left: 30px !important;
  }
  ol {
    list-style: unset !important;
    list-style-type: decimal !important;
    //list-style-position: inside !important;
    padding-left: 30px !important;
  }
  ol li, ul li {
    list-style: unset !important;
    display: list-item !important;
  }
  span {
    display: block;
    color: grey;
    font-size: 0.8rem;
  }
  hr {
    margin: 10px 0;
    border: 0;
    border-bottom: 1px solid rgb(230, 230, 230);
  }
  strong, .ssstrong strong { font-weight: 900 !important; }
}
</style>
